import { Injectable } from "@angular/core";
import { ProductServiceInterface } from "@app/models/interfaces/product-service.interface";
import { TaqmanSearchResponseInterface } from "@app/models/responses/taqman-search-response.interface";
import { GXProductInterface } from "@app/products/ge/arrays/models/interfaces/gx-product.interface";

@Injectable({providedIn: "root"})
export class GXProductService implements ProductServiceInterface {

    makeProductFromSearchResult(searchResult: TaqmanSearchResponseInterface): GXProductInterface[] {

        return searchResult.products.map((product) => {

            const newProduct: GXProductInterface = {
                assayDesign: product.assayDesign,
                availability: product.availability,
                defaultCatalogNum: product.defaultCatalogNum,
                packageId: product.packageId,
                partNumber: product.partNumber,
                plateSubType: product.plateSubType,
                productFormat: product.productFormat,
                productID: product.productID,
                productName: product.productName,
                productSubType: product.productSubType,
                productType: product.productType,
                quantity: 1,
                samplesPerPlate: product.samplesPerPlate,
                selectedCatalogNumber: product.defaultCatalogNum,
                species: product.species,
                taqmanProductID: product.productID, // unique ID for the UI
                webID: product.webID
            }

            return newProduct;

        });

    }

}
